import { render, staticRenderFns } from "./ViewMyAcademy.vue?vue&type=template&id=45a69abf&scoped=true"
import script from "./ViewMyAcademy.vue?vue&type=script&lang=js"
export * from "./ViewMyAcademy.vue?vue&type=script&lang=js"
import style0 from "./ViewMyAcademy.vue?vue&type=style&index=0&id=45a69abf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a69abf",
  null
  
)

export default component.exports